import styled from 'styled-components';

const DragAndDropArea = styled.div`
  position: relative;
  width: 100%;
  background: #ffffff;
  /* Colores UTP+ web - app/Primario */

  border: 1px dashed #5b36f2;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 16px 0px 0px;
  align-items: center;
  justify-content: center;
  align-content: center;
  display: flex;
  min-height: 96px;
  /* Inside Auto Layout */

  /* flex: none;
  order: 1;
  flex-grow: 0;
  margin: 16px 0px; */
  .trash {
    position: static;
    right: 4px;
    top: 8px;
  }
  button cc-icon {
    color: #5b36f2;
    margin-right: 4px;
  }
  .IElement {
    position: absolute;
    left: calc((100% - 141px) / 2);
    top: calc((100% - 40px) / 2);
  }
  &.isDisabled {
    border: 1px dashed #8090bb;
  }
  &.isDisabled button:hover {
    background: none;
  }
  &.isDisabled cc-icon {
    color: #8090bb !important;
  }

  &.isDisabled,
  &.isDisabled button {
    cursor: no-drop;
  }

  &.isDisabled button > div > div {
    color: #8090bb;
  }

  &.isDisabled button cc-icon {
    color: #8090bb;
  }

  &.isDragged {
    border: 1px dashed #2e0e93;
  }

  &.isDragged button > div > div {
    color: #2e0e93;
  }

  &.isDragged button cc-icon {
    color: #2e0e93;
  }

  @media (max-width: 768px) {
  }

  span.messageOver {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #2e0e93;
  }
`;

const WrapLoader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  cc-loader {
    color: #5b36f2;
  }
  @media (max-width: 768px) {
  }
`;

const WrapRemoveSingleFile = styled.div`
  cc-icon {
    color: #1a055d;
  }

  &:hover cc-icon {
    color: #745ef6;
  }

  &:focus cc-icon {
    color: #4318cd;
  }

  &:active cc-icon {
    color: #4318cd;
  }

  @media (max-width: 768px) {
  }
`;

const WrapWarning = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 32px;
  flex-direction: row;
  padding: 8px;
  border-top: 1px solid #bfd8e9;
  width: 100%;
  cc-icon {
    color: #e8212b;
  }

  @media (max-width: 768px) {
  }
`;

export { DragAndDropArea, WrapLoader, WrapRemoveSingleFile, WrapWarning };
